// extracted by mini-css-extract-plugin
export default {"wrapper":"jv-z","addressLine":"kv-z","fullName":"lv-z"};